import React from "react";

function USDFigure({ amount }) {
  return (
    <p>
      {amount?.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      })}
    </p>
  );
}

export default USDFigure;
